import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, TextField }  from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import AddEquipmentRow from '../AddEquipmentRow';

//For everyone playing along at home, this uses some different components than our other modals,
//but I kinda like this one.  Let's give a thumbs up/down to the different approaches and then
//come back and refactor for consistency

export default function FormDialog(props) {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const handleClose = () => {
        setOpen(false)
    };

    const handleSubmit = () => {
        props.handleSubmit().then(() => {
            setOpen(false)
        })
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Add New Equipment</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You may add equipment to the site generally (in cases such as a PV array), a building (often for rooftop units), a space (room), or a zone.  You are currently entering equipment for {props.location}.
                </DialogContentText>
                <AddEquipmentRow key={props.element_id + "0"} row_num={0} callback={props.equipmentToAddCallback} equipmentTypes={props.brickTypes} systems={props.systems} products={props.products} equipment={props.equipment} elementId={props.elementId} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}